import { Controller } from "@hotwired/stimulus"

const ACTIVE_VIEW_BUTTON_CLASSES = ["bg-[#7D3C77]", "text-white", "shadow-sm"]
const INACTIVE_VIEW_BUTTON_CLASSES = ["text-slate-700"]
const ACTIVE_DAY_BUTTON_CLASSES = ["border-[#7D3C77]", "bg-[#7D3C77]", "text-white", "shadow-sm"]
const INACTIVE_DAY_BUTTON_CLASSES = ["border-slate-200", "bg-white", "text-slate-700"]
const MOBILE_MEDIA_QUERY = "(max-width: 767px)"

export default class extends Controller {
  static targets = ["panel", "toggleButton", "dayButton", "dayPanel"]
  static values = {
    initialView: String,
    selectedDate: String
  }

  connect() {
    this.currentView = this.resolveInitialView()
    this.currentDate = this.resolveInitialDate()

    this.renderView()
    this.renderDate()
    this.notifyHeightChanged()
  }

  switchView(event) {
    const nextView = this.normalizeView(event.currentTarget.dataset.view)
    if (!this.isValidView(nextView)) return
    if (nextView === this.currentView) return

    this.currentView = nextView
    this.renderView()
    this.notifyHeightChanged()
  }

  selectDate(event) {
    const nextDate = event.currentTarget.dataset.date
    if (!nextDate) return

    this.currentDate = nextDate
    this.renderDate()
    this.notifyHeightChanged()
  }

  renderView() {
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.view !== this.currentView)
    })

    this.toggleButtonTargets.forEach((button) => {
      const active = button.dataset.view === this.currentView
      this.toggleClasses(button, ACTIVE_VIEW_BUTTON_CLASSES, active)
      this.toggleClasses(button, INACTIVE_VIEW_BUTTON_CLASSES, !active)
    })
  }

  renderDate() {
    if (!this.currentDate) return

    this.dayButtonTargets.forEach((button) => {
      const active = button.dataset.date === this.currentDate
      this.toggleClasses(button, ACTIVE_DAY_BUTTON_CLASSES, active)
      this.toggleClasses(button, INACTIVE_DAY_BUTTON_CLASSES, !active)
    })

    this.dayPanelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.date !== this.currentDate)
    })
  }

  resolveInitialView() {
    const requested = this.normalizeView(this.initialViewValue)
    if (this.isValidView(requested)) return requested

    const isMobile = window.matchMedia(MOBILE_MEDIA_QUERY).matches
    return isMobile ? "list" : "month"
  }

  resolveInitialDate() {
    if (this.selectedDateValue) return this.selectedDateValue
    return this.dayButtonTargets[0]?.dataset.date || this.dayPanelTargets[0]?.dataset.date || ""
  }

  isValidView(view) {
    return ["list", "month"].includes(view)
  }

  normalizeView(view) {
    if (view === "agenda") return "list"
    return view
  }

  toggleClasses(element, classNames, shouldAdd) {
    classNames.forEach((className) => {
      element.classList.toggle(className, shouldAdd)
    })
  }

  notifyHeightChanged() {
    window.dispatchEvent(new Event("embed:content-resized"))
  }
}
